import Box from '@mui/material/Box';

import { usePathname } from 'src/routes/hooks';

import Footer from './footer';
import Header from './header';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  const homePage = pathname === '/';

  // The home page keeps normal document scrolling: its hero animation and
  // scroll-progress bar track window scroll.
  if (homePage) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
        <Header />

        <Box component="main" sx={{ flexGrow: 1 }}>
          {children}
        </Box>

        <Footer />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
      }}
    >
      <Header />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflowY: 'auto',
          mt: { xs: 8, md: 10 },
        }}
      >
        {children}
      </Box>

      <Footer dense />
    </Box>
  );
}
